import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ErrorBoundary from './components/global/ErrorBoundary';
import NotFound from './components/global/NotFound';
import { IntroRoute, UnprotectedRoute, ProtectedRoute } from './helpers/AuthRouter';
import FontLoader from './helpers/FontLoader';
import MessageProvider from './helpers/MessageProvider';
import NTRIPProvider from './helpers/NTRIPProvider';
import StoreProvider from './helpers/StoreProvider';
import { ModalContainer } from './libs/Modal';
import { NotifierContainer } from './libs/Notifier';
import AutoLogin from './pages/autologin';
import ControlCenter from './pages/control-center';
import DJIPilot from './pages/dji/pilot';
import FlightReview from './pages/flight-review';
import Login from './pages/login';
import MissionHub from './pages/mission-hub';
import VideoManager from './pages/video-manager';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<IntroRoute />} />
      <Route
        path="/login"
        element={
          <UnprotectedRoute>
            <Login />
          </UnprotectedRoute>
        }
      />
      <Route
        path="/autologin"
        element={
          <UnprotectedRoute>
            <AutoLogin />
          </UnprotectedRoute>
        }
      />
      <Route
        path="/control-center"
        element={
          <ProtectedRoute>
            <MessageProvider>
              <NTRIPProvider>
                <ModalContainer />
                <ControlCenter />
              </NTRIPProvider>
            </MessageProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mission-hub/:id?"
        element={
          <ProtectedRoute>
            <MessageProvider>
              <ModalContainer />
              <MissionHub />
            </MessageProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="/video-manager"
        element={
          <ProtectedRoute>
            <ModalContainer />
            <VideoManager />
          </ProtectedRoute>
        }
      />
      <Route
        path="/flight-review"
        element={
          <ProtectedRoute>
            <ModalContainer />
            <FlightReview />
          </ProtectedRoute>
        }
      />
      <Route path="/dji/pilot" element={<DJIPilot />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <FontLoader />
      <NotifierContainer />
      <StoreProvider>
        {process.env.REACT_APP_USE_ERROR_BOUNDARY === 'true' && (
          <ErrorBoundary>
            <AppRoutes />
          </ErrorBoundary>
        )}
        {process.env.REACT_APP_USE_ERROR_BOUNDARY !== 'true' && <AppRoutes />}
      </StoreProvider>
    </BrowserRouter>
  );
};

export default App;
